import { render, staticRenderFns } from "./OpportunityMarket.vue?vue&type=template&id=894b7508&scoped=true&"
import script from "./OpportunityMarket.vue?vue&type=script&lang=js&"
export * from "./OpportunityMarket.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityMarket.vue?vue&type=style&index=0&id=894b7508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894b7508",
  null
  
)

export default component.exports